export const CourseTemplateMappingsClass = "CourseTemplateMappings";
export const CourseLengthsClass = "CourseLengths";
export const CoursePacingsClass = "CoursePacings";
export const CourseTemplatesClass = "CourseTemplates";
export const CourseHolidaysClass = "CourseHolidays";
export const SemesterClass = "Semester";
export const UserDataClass = "UserData";
export const UserClass = "User";
export const CoursesClass = "Courses";
